//Splide Testimonials
import Splide from "@splidejs/splide";

const classExists = document.getElementsByClassName('testimonials').length > 0;

if (classExists) {
    const splideTestimonials = new Splide('.splide.testimonials', {
        //type   : 'loop',
        rewind: true,
        focus: 'center',
        perPage: 1,
        //lazyLoad: 'nearby',
        pagination: false,
        autoplay: false,
        drag: false,
    });
    splideTestimonials.mount();
}